import URL from './urls';
import DIALOG_ACTIONS, {DIALOG_TYPES} from './dialogs';
import VIEWPORT_ACTIONS, {BUTTON_TYPES} from './layout';
import {FORM_INPUT_STATES} from './form';
import {
  USER_ACTIONS,
  STORAGE_USER_NAMESPACE,
} from './users';
import {ACTIONS as SESSION_ACTIONS, NAMESPACES as SESSION_NAMESPACES, STORAGE_SESSION_NAMESPACE} from './sessions';
import {ACTIONS as FLOWS_ACTIONS} from './flows';
import {ACTIONS as DATA_ACTIONS, STORAGE_SERVER_DATA_NAMESPACE} from './data';
import {ACTIONS as VIDEOSESSION_ACTIONS, STORAGE_VIDEOSESSION_NAMESPACE} from './videosession';
import {ACTIONS as CART_ACTIONS, STORAGE_CART_NAMESPACE} from './cart';
import {ACTIONS as SOCKET_ACTIONS} from './socket';

export default function ConstantsStorage() {
  return {
    URL,
    DIALOG_ACTIONS,
    DIALOG_TYPES,
    BUTTON_TYPES,
    VIEWPORT_ACTIONS,
    USER_ACTIONS,
    DATA_ACTIONS,
    FORM_INPUT_STATES,
    SESSION_ACTIONS,
    SESSION_NAMESPACES,
    STORAGE_SERVER_DATA_NAMESPACE,
    STORAGE_USER_NAMESPACE,
    STORAGE_SESSION_NAMESPACE,
    FLOWS_ACTIONS,
    VIDEOSESSION_ACTIONS,
    STORAGE_VIDEOSESSION_NAMESPACE,
    SOCKET_ACTIONS,
    CART_ACTIONS,
    STORAGE_CART_NAMESPACE,
  };
}
